<template>
  <div class="netd-content">
    <div class="netd-title">
      {{detail.title}}
    </div>
    <div class="netd-title2">
      <p>发布日期：{{time}}</p>
      <p>出处：{{detail.field1}}</p>
      <p>阅读次数：{{detail.viewNum}}</p>
    </div>
    <div class="netd-news" v-html="detail.content"></div>
    <!-- <div v-if="detail.hrefType == 1" class="netd-news" v-html="detail.content"></div>
    <div v-else class="netd-news">
      <iframe height=450 width=800 :src="detail.href" frameborder=0></iframe>
    </div> -->

  </div>
</template>
<script>
import moment from 'moment'

export default {
  props:{
    detail:Object
  },
  computed: {
    time() {
      return this.detail.publishTime ? moment(this.detail.publishTime).format('YYYY-MM-DD'): "";
    }
  },
}
</script>
<style lang="scss" >
.netd-content{
  margin-top: 30px;
  margin-bottom: 50px;
  .netd-title{
    font-size: 26px;
    font-family: Helvetica;
    color: #333333;
    line-height: 26px;

  }
  .netd-title2{
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    p{
      margin-right: 40px;
      font-size: 12px;
      font-family: Helvetica;
      color: #727384;
      line-height: 14px;
    }
  }
  .netd-news{
    padding: 20px;
    position: relative;
    .text_align-justify{
      text-align: center;
      img{
        margin:0 auto;
      }
    }
  }
}
</style>